import CONSTANTS from 'services/CONSTANTS';
export default {
    secretNotes: function (entity) {
        this.guard(CONSTANTS.CRUD.UPDATE, entity);
        return entity.secretNotes;
    },
    isAdmin: function () {
        return this.child.role === CONSTANTS.ROLES.ADMIN;
    },
    isDriver: function () {
        return this.child.role === CONSTANTS.ROLES.DRIVER;
    },
    isCreator: function (entity) {
        return this.child.id === entity.author.id;
    },
    expose: [
        'secretNotes'
    ]
};



//////////////////
// WEBPACK FOOTER
// ./services/kindergarten/perimeters/Checks.ts
// module id = ./services/kindergarten/perimeters/Checks.ts
// module chunks = 0 1 3 10 11 15 18 21 22